/** @jsx createElementEntity */
import { Attrs, createElementEntity, createRef, Ref } from "../utils/jsx-entity";
import { Layers } from "../camera-layers";
import buttonSrc from "../assets/hud/icon_photo.png";
import { Texture } from "three";
import { textureLoader } from "../utils/media-utils";
const buttonTexture = textureLoader.load(buttonSrc);

export enum BUTTON_TYPES {
  DEFAULT = 0,
  ACTION = 1
}

type ButtonType = BUTTON_TYPES.DEFAULT | BUTTON_TYPES.ACTION;

export interface Refable {
  ref?: Ref;
}

export interface Button3DParams extends Attrs {
  text: string;
  width: number;
  height: number;
  texture?: Texture;
  name?: string;
  type: ButtonType;
  labelRef?: Ref;
  holdable?: true;
  holdableButton?: true;
  object3D?:any
}

export function Button3DCamera({
  text = '',
  width,
  height,
  texture = buttonTexture,
  name = "Button",
  type,
  object3D,
  ...props
}: Button3DParams) {


  const labelRef = createRef();
  return (
      <entity
        name={name}
        object3D={object3D}
        cursorRaycastable
        remoteHoverTarget
        hoverButton={{ type }}
        textButton={{ labelRef }}
        singleActionButton
        layers={1 << Layers.CAMERA_LAYER_UI}
        {...props}
      >
        <entity
          ref={labelRef}
          layers={1 << Layers.CAMERA_LAYER_UI}
          text={{ value: text, color: "#000000", textAlign: "center", anchorX: "center", anchorY: "middle", fontSize: 0.015, zOffset: 0.003 }}
          position={[-0.001, -0.04, 0]}
          name={`${name} Label`}
          hoverButton={{ type }}
        />
      {/* {text && (
        <entity
          ref={labelRef}
          layers={1 << Layers.CAMERA_LAYER_UI}
          text={{ value: text, color: "#000000", textAlign: "center", anchorX: "center", anchorY: "middle", fontSize: 0.01 }}
          position={[-0.001, -0.024, 0]}
          name={`${name} Label`}
          hoverButton={{ type }}
        />

      )}
      {!text && (
        <entity
          ref={labelRef}
          layers={1 << Layers.CAMERA_LAYER_UI}
          position={[-0.001, -0.024, 0]}
          name={`${name} Label`}
          hoverButton={{ type }}
        />
      )} */}

      </entity>

  );
}
